var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-area'),_c('section',{staticClass:"flightbooking_area"},[(_vm.device==='mobile')?_c('mobile-sticky-header'):_vm._e(),_c('booking-flight-area'),(_vm.device==='mobile')?_c('mobile-sticky-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }